import EmailUpdateAccountMessage from "../../components/EmailUpdateAccountMessage";
import PasswordBg from "../../assets/img/passwordbg.png";
import "./ProfileEmailUpdated.scss";

interface Props {}

const ProfileEmailUpdated: React.FC<Props> = () => {
  return (
    <EmailUpdateAccountMessage
      title={"You have successfully updated your account."}
      link="/login"
      img={PasswordBg}
    />
  );
};

export default ProfileEmailUpdated;
